"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var caution_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/caution.icon.svg"));
var close_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/close.icon.svg"));
var exclamation_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/exclamation.icon.svg"));
var information_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/information.icon.svg"));
var security_tip_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/security-tip.icon.svg"));
var success_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/success.icon.svg"));
var typography_1 = require("@kaizen/typography");
var GenericNotification_module_scss_1 = __importDefault(require("./GenericNotification.module.scss"));
var GenericNotification = /** @class */ (function (_super) {
    __extends(GenericNotification, _super);
    function GenericNotification(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hidden: true,
            removed: false
        };
        _this.autoHideTimeoutId = null;
        _this.containerRef = react_1["default"].createRef();
        _this.hide = _this.hide.bind(_this);
        _this.onTransitionEnd = _this.onTransitionEnd.bind(_this);
        return _this;
    }
    GenericNotification.prototype.componentDidMount = function () {
        var _this = this;
        requestAnimationFrame(function () {
            if (_this.containerRef.current) {
                _this.setState({ hidden: false });
            }
        });
        if (["toast", "inline"].includes(this.props.style) && this.props.autohide) {
            this.autoHideTimeoutId = setTimeout(this.hide, this.autohideDelayMs());
        }
    };
    GenericNotification.prototype.componentWillUnmount = function () {
        if (this.autoHideTimeoutId) {
            clearTimeout(this.autoHideTimeoutId);
            this.autoHideTimeoutId = null;
        }
    };
    GenericNotification.prototype.autohideDelayMs = function () {
        if (this.props.autohideDelay == "long") {
            return 30000;
        }
        else {
            return 5000;
        }
    };
    GenericNotification.prototype.render = function () {
        if (this.state.removed) {
            return null;
        }
        return (react_1["default"].createElement("div", { className: this.className(), style: { marginTop: this.marginTop() }, ref: this.containerRef, onTransitionEnd: this.onTransitionEnd, "data-automation-id": this.props.automationId, "data-testid": this.props.automationId, "data-automation-class": (0, classnames_1["default"])("generic-notification", this.props.type, this.props.style) },
            react_1["default"].createElement("div", { className: GenericNotification_module_scss_1["default"].icon },
                react_1["default"].createElement(component_library_1.Icon, { icon: this.iconType(), role: "presentation", inheritSize: true })),
            react_1["default"].createElement("div", { className: this.textContainerClassName() },
                this.props.style !== "global" && (react_1["default"].createElement(NotificationHeading, { titleProp: this.props.title, headingProps: this.props.headingProps })),
                this.props.children && (react_1["default"].createElement("div", { className: GenericNotification_module_scss_1["default"].text }, this.props.children))),
            !this.props.persistent && react_1["default"].createElement(CancelButton, { onClick: this.hide })));
    };
    GenericNotification.prototype.className = function () {
        return (0, classnames_1["default"])(GenericNotification_module_scss_1["default"].notification, GenericNotification_module_scss_1["default"][this.props.type], GenericNotification_module_scss_1["default"][this.props.style], this.state.hidden && GenericNotification_module_scss_1["default"].hidden, this.props.noBottomMargin && GenericNotification_module_scss_1["default"].noBottomMargin, this.props.classNameOverride);
    };
    GenericNotification.prototype.textContainerClassName = function () {
        return (0, classnames_1["default"])(GenericNotification_module_scss_1["default"].textContainer, this.props.forceMultiline && GenericNotification_module_scss_1["default"].forceMultiline);
    };
    GenericNotification.prototype.marginTop = function () {
        if (this.state.hidden && this.containerRef.current) {
            return -this.containerRef.current.clientHeight + "px";
        }
        return "0";
    };
    GenericNotification.prototype.onTransitionEnd = function (e) {
        // Be careful: this assumes the final CSS property to be animated is "margin-top".
        if (this.state.hidden && e.propertyName === "margin-top") {
            this.setState({ removed: true });
            if (this.props.onHide) {
                this.props.onHide();
            }
        }
    };
    GenericNotification.prototype.iconType = function () {
        switch (this.props.type) {
            case "positive":
                return success_icon_svg_1["default"];
            case "negative":
                return exclamation_icon_svg_1["default"];
            case "cautionary":
                return caution_icon_svg_1["default"];
            case "informative":
                return information_icon_svg_1["default"];
            case "security":
                return security_tip_icon_svg_1["default"];
            default:
                return information_icon_svg_1["default"];
        }
    };
    GenericNotification.prototype.hide = function () {
        this.setState({ hidden: true });
    };
    GenericNotification.defaultProps = {
        persistent: false,
        autohide: false,
        autohideDelay: "short"
    };
    return GenericNotification;
}(react_1["default"].Component));
var CancelButton = function (_a) {
    var onClick = _a.onClick;
    return (react_1["default"].createElement("button", { className: GenericNotification_module_scss_1["default"].cancel, type: "button", onClick: onClick, "data-testid": "close-button" },
        react_1["default"].createElement(component_library_1.Icon, { icon: close_icon_svg_1["default"], role: "img", title: "close notification" })));
};
var NotificationHeading = function (_a) {
    var titleProp = _a.titleProp, headingProps = _a.headingProps;
    if (headingProps) {
        return (react_1["default"].createElement(typography_1.Heading, { variant: headingProps.variant || "heading-6", tag: headingProps.tag || "div", color: headingProps.color || "dark", classNameOverride: GenericNotification_module_scss_1["default"].notificationTitle }, headingProps.children));
    }
    else if (titleProp) {
        return (react_1["default"].createElement(typography_1.Heading, { variant: "heading-6", tag: "div", color: "dark", classNameOverride: GenericNotification_module_scss_1["default"].notificationTitle }, titleProp));
    }
    else
        return null;
};
exports["default"] = GenericNotification;
//# sourceMappingURL=GenericNotification.js.map